import styled from "styled-components";

interface SearchProps {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
}

export default function Search({ value, onChange, placeholder }: SearchProps) {
  return (
    <SearchLayout>
      <SearchInput type="text" name="search" value={value} onChange={onChange} placeholder={placeholder} />
      {/* <SearchBtn type="submit">검색</SearchBtn> */}
    </SearchLayout>
  );
}

const SearchLayout = styled.form`
  height: 2.25rem;
  width: 210px;
  border: 1px solid #D9D9D9;
  border-radius: 0;
`;

const SearchInput = styled.input`
  width: 100%;
  height: 100%;
  padding-left: 0.625rem;
  border: none;
  /* border-right: 1px solid #D9D9D9; */
`;

// const SearchBtn = styled.button`
//   color: #212529;
//   font-size: 0.875rem;
//   font-weight: 600;
//   border: 0;
//   border-radius: none;
// `;